import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BaseService } from 'src/app/shared/services';
import { DownloadService } from 'src/app/shared/services/download.service';
import { IWGSharedService } from 'src/app/shared/services/shared.service';
import { UserService } from 'src/app/shared/services/user.service';
import { AlertMessageComponent } from '../file-upload/alert-message/alert-message.component';
@Component({
  selector: 'app-multiple-file-upload',
  templateUrl: './multiple-file-upload.component.html',
  styleUrls: ['./multiple-file-upload.component.scss']
})
export class MultipleFileUploadComponent implements OnInit {
  fileHasScanError = false;
  fileHasScanTimeOutError = false;
  fileHasLargeSizeError = false;
  scanErrorMessage = null;
  scanTimeOutErrorMessage = null;
  largeSizeErrorErrorMessage = null;
  dialogRef:any = null;
  allfiles:any[];
  allowedFileTypeExtensions:any;
  @Input("file-property") fileProperty;
  @Input("upload-url") uploadUrl;
  @Input ("required") required = false;
  @Input("uploaded-file-name") documentFileList;
  // @Output() public getUserData = new EventEmitter<any>();
  @Output() create = new EventEmitter<any>();
  isFileUploading:boolean = false;
  isFileUploaded:boolean = false;
  fileUploadError:boolean = false;
  invalidFiles=[];

  constructor(
    private userService: UserService, private dialog: MatDialog,
    private baseService: BaseService, private down: DownloadService, private sharedService:IWGSharedService
  ) { 
    this.allowedFileTypeExtensions = userService.getAllowedFileTypeExtensions();
  }

  ngOnInit(): void {
  }
  onClick(): void{
    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.onchange = () => {
      const file = fileUpload.files;
      this.uploadFiles(file);
    };
    fileUpload.click();
  }
  uploadFiles(file){
    if(!file){
      return;
    }
    if (file) {
      let data = {document_attachment_file:[]}


      var invalidFiles = [];
      this.scanErrorMessage = null;
      this.scanTimeOutErrorMessage = null;
      this.largeSizeErrorErrorMessage = null;
      this.isFileUploading = false;
      this.fileHasScanError = false;
      this.fileHasScanTimeOutError = false;
      this.fileHasLargeSizeError = false;
      var length = Array.from(file).length;
      //Used for instead of forEach since forEach not working with files.
      for (var index = length-1; index >= 0; index--) {
          var isValidFile = true;
          if (!this.userService.validateSelectedFileType(file[index].name, file[index].type)) {
              invalidFiles.push(file[index].name);
              isValidFile = false;
          }
          if (!isValidFile) { //Remove the invalid file from file property
              file.splice(index, 1);
          }
      }
      if (invalidFiles.length > 0) { //Show invalid error for not supported file types
          alert(this.userService.getFileUploadUnSupportErrorMessage(invalidFiles.join(','), true));
      }
      if (Array.from(file).length <= 0) { //Don't upload if there's no content.
          return;
      }
      this.openDialog();
      data[this.fileProperty].push(file); 
      this.isFileUploading = true;
      var formData = new FormData();
      for (var index = 0; index < length; index++) {     
      // 'document_attachment_file' + [index]
        formData.append('document_attachment_file[' + [index]+']', file[index]);
        // formData.append('document_attachment_file[upload][$state][status]', '0');
        // formData.append('document_attachment_file[upload][$state][pending][0][0][promise][$state][status]', '0');
        // formData.append('document_attachment_file[upload][$state][pending][1][0][promise][$state][status]', '0');
      }
      this.down.upload(this.uploadUrl,formData)
      .then(
        resp => {
          this.closeDialog();         
          // $rootScope.$emit('iwg.file.upload.status', false);
          if (resp.data.ErrorCode) {
            if (resp.data.ErrorCode != 200)
                        {
                            this.fileHasScanError = true;
                            var errorFileName = null, timeOutFiles = [], largeFiles = [];
                            this.allfiles = resp.data.Data;
                            var successFiles = [];
                            //ctrl.uploadedFiles = existingUploadedFiles; //Reset to already uploaaded list.
                            this.allfiles.forEach(function (files)
                            {
                                if (files.ErrorCode === 406) { //File contain virus
                                    if (errorFileName && errorFileName !== null) {
                                        errorFileName = errorFileName + ',' + files.FileName;
                                    } else {
                                        errorFileName = files.FileName;
                                    }
                                } else if (files.ErrorCode === 202) { //Scan request time-out
                                    timeOutFiles.push(files.FileName);
                                } else if (files.ErrorCode === 413) { //File size too large
                                    largeFiles.push(files.FileName);
                                }
                                else {
                                    successFiles.push(files);
                                    //ctrl.uploadedFiles.push({ Name: files.FileName, isValidFile: true });
                                }
                            });
                            if (errorFileName && errorFileName !== null) {
                                this.scanErrorMessage = 'These file(s) ' + errorFileName + ' may not be uploaded. It has been found to contain malicious code.';
                            }
                            if (timeOutFiles.length > 0) {
                              this.fileHasScanTimeOutError = true;
                              this.scanTimeOutErrorMessage = 'Request timeout! these file(s) ' + timeOutFiles.join(',') +' are unable to upload, please try again later.';
                            }
                            if (largeFiles.length > 0) {
                              this.fileHasLargeSizeError = true;
                              this.largeSizeErrorErrorMessage = 'These file(s) ' + largeFiles.join(',') + ' may not be uploaded. Uploaded file size is larger than allowed file size of ' + this.userService.getSophosMaximumFileScanSize()+'MB.';
                            }
                            resp.data.Data = successFiles;
                        }
              this.isFileUploaded = false;
              this.fileUploadError = false;
              this.isFileUploading=false;
              // this.uploadedFileName = resp.config.data[this.fileProperty].name;
              // console.log('Success ' + resp.config.data[this.fileProperty].name + ' uploaded');
              // $rootScope.$emit('iwg.file.uploaded');
              this.create.emit(resp.data.Data);
          } else {
              if (resp.data.ErrorCode === 406 || resp.data.ErrorCode === 413 || resp.data.ErrorCode == 400)
              {
                  this.fileHasScanError = true;
                  this.scanErrorMessage = resp.data.ErrorMessage;
              }
              else {
                  this.fileUploadError = true;
              }
              console.error('Error uploading file', resp);
          }
        }
      )
      .catch(
        err => {
          this.closeDialog();
          console.log(err);
          this.isFileUploading = false;
          this.fileUploadError = true;
        }
      );
    }

  }
  openDialog(): void {
    this.dialogRef = this.dialog.open(AlertMessageComponent, {disableClose: true});
  }
    closeDialog(): void {
    this.dialogRef.close();
  }
}
